"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentMethod = void 0;
var PaymentMethod;
(function (PaymentMethod) {
    PaymentMethod["Invoice"] = "invoice";
    PaymentMethod["ValueVoucher"] = "valueVoucher";
    PaymentMethod["StripeCreditCard"] = "stripeCreditCard";
    PaymentMethod["PayPal"] = "paypal";
    PaymentMethod["AmazonPay"] = "amazonPay";
    PaymentMethod["Sofort"] = "sofort";
    PaymentMethod["StripeKlarna"] = "stripeKlarna";
    PaymentMethod["StripeGooglePay"] = "stripeGooglePay";
    PaymentMethod["StripeApplePay"] = "stripeApplePay";
})(PaymentMethod || (exports.PaymentMethod = PaymentMethod = {}));
//# sourceMappingURL=PaymentMethod.js.map